import { render, staticRenderFns } from "./create_liff.vue?vue&type=template&id=31bcf09b&"
import script from "./create_liff.vue?vue&type=script&lang=js&"
export * from "./create_liff.vue?vue&type=script&lang=js&"
import style0 from "./create_liff.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports